import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';

// Define expected data structure for this node
interface MappingNodeData {
  label?: string;
  mappingCount?: number; // Example: show how many mappings are configured
}

const MappingNode: React.FC<NodeProps<MappingNodeData>> = ({ data }) => {
  const label = data?.label || 'Mappings';
  const count = data?.mappingCount ?? 0;

  return (
    <div className="playbook-node mapping-node" style={{ width: 180 }}>
      <Handle type="target" position={Position.Left} id="input" style={{ background: '#555' }} />
      <div className="playbook-node-header" style={{ justifyContent: 'center' }}>
        <strong>{label}</strong>
      </div>
      <div style={{ padding: '5px 0', fontSize: '0.9em', color: '#555', textAlign: 'center' }}>
        ({count} configured)
      </div>
      <Handle type="source" position={Position.Right} id="output" style={{ background: '#555' }} />
    </div>
  );
};

export default MappingNode;
